import React from 'react'

import { useSelector, useDispatch } from 'react-redux'
import { selectAccountConfig, selectCurrentPath, selectRoutes, selectIsElectron } from '@selectors'

import { useParams, useHistory } from 'react-router-dom'

import dayjs from 'dayjs'

import { Button, GRADIENTS } from '@omnilert/components'

import SafeWalkTimer from '@components/safewalk-timer/safewalk-timer.component'

import { SAFEWALK_SET_DATA } from '@actions/types'

import {
  SAFEWALK_BUTTON_ALARM_ACTIVE_TEXT,
  SAFEWALK_BUTTON_BEGIN_TEXT,
  SAFEWALK_BUTTON_WALK_ACTIVE_TEXT,
  SAFEWALK_BUTTON_WARNING_TEXT
} from '@assets/i18n/strings'

import i18n from 'i18n-js'

import useStyles from './safewalk-button.style'

const BUTTON_TITLE = [{
  backgroundColor: GRADIENTS.SUCCESS,
  state: 'walk-activated',
  text: SAFEWALK_BUTTON_WALK_ACTIVE_TEXT,
  showTimer: true
},
{
  backgroundColor: GRADIENTS.WARNING,
  state: 'warning',
  text: SAFEWALK_BUTTON_WARNING_TEXT,
  showTimer: true
},
{
  backgroundColor: GRADIENTS.ERROR,
  state: 'alarm-active',
  text: SAFEWALK_BUTTON_ALARM_ACTIVE_TEXT,
  showTimer: true
}]

const DEFAULT_BUTTON_TITLE = {
  backgroundColor: GRADIENTS.INFO,
  state: '',
  text: SAFEWALK_BUTTON_BEGIN_TEXT,
  showTimer: false
}

const SafeWalkButton = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const { personalAccessCode } = useParams()

  const accountConfig = useSelector(selectAccountConfig)
  const currentPath = useSelector(selectCurrentPath)
  const routes = useSelector(selectRoutes)
  const isElectron = useSelector(selectIsElectron)
  const { activeDisplay } = useSelector(state => state.safewalk)

  const activeState = activeDisplay?.state
  const { safe_walk: safeWalkConfig } = { ...accountConfig }

  const currentRoute = routes.find(({ path }) => path === currentPath)

  const hideButton = isElectron || !safeWalkConfig || !safeWalkConfig.enable_safe_walk || currentRoute?.tab?.path.includes('safewalk')

  const BUTTON_TITLE_STATE = BUTTON_TITLE.find(({ state }) => state === activeState) || DEFAULT_BUTTON_TITLE

  const { backgroundColor, text, showTimer } = BUTTON_TITLE_STATE

  const classes = useStyles({ backgroundColor })
  
  if (hideButton) return null

  const { hours_of_operation: hoursOfOperation } = { ...safeWalkConfig }
  const { end_time: endTime, start_time: startTime } = hoursOfOperation

  const formatStartTime = dayjs().hour(startTime.hour).minute(startTime.min)
  const formatEndTime = dayjs().hour(endTime.hour).minute(endTime.min)

  const isDuringHours = dayjs().isBetween(formatStartTime, dayjs(formatEndTime), 'minutes')

  const onClickStart = async () => {
    dispatch({
      type: SAFEWALK_SET_DATA,
      payload: {
        isOffHours: !isDuringHours
      }
    })

    history.push(`/${personalAccessCode}/safewalk`)
  }

  const renderCountdown = () => {
    return (
      <div>
        <span>{i18n.t(text)} </span>
        {activeState && <SafeWalkTimer />}
      </div>
    )
  }

  return (
    <div className={classes.container}>
      <Button
        className={classes.button}
        fullWidth
        hoverBackgroundColor={backgroundColor}
        onClick={onClickStart}
        size='lg'
        title={showTimer ? renderCountdown() : i18n.t(text)}
        titleClassName={classes.title}
        variant='solid'
      />
    </div>
  )
}

export default SafeWalkButton
